import React from "react";

import Styles from "./Marker.styles";
import { MarkerProps as Props } from "./Marker.types";

import PinSVG from "../../../../../public/assets/images/pin.svg";

const Marker: React.FC<Props> = props => {
  const { icon } = props;
  const localIcon = icon ?? <PinSVG />;

  return <Styles className="Marker">{localIcon}</Styles>;
};

Marker.defaultProps = {};

export default Marker;
